module.exports = __webpack_public_path__ + "fonts/AvenirNextCyr-HeavyItalic.fd1b36d2.eot";